import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import en from "../locales/en.json"
import es from "../locales/es.json"

function getInitialLocale(): string {
    const match = document.cookie.match(/(?:^|;\s*)locale=([^;]*)/)
    return match?.[1] === "es" ? "es" : "en"
}

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        es: { translation: es },
    },
    lng: getInitialLocale(),
    fallbackLng: "en",
    interpolation: { escapeValue: false },
})

export default i18n
